// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tab_tabs__3b2dB","tab":"tab_tab__1DmRM","active":"tab_active__RxPbn"};